import {
  BaseEntityDataInputDto,
  EntityDataOriginMode,
  EntityFormType,
} from "@/core/api/generated/v1";

import { ArrayHelper } from "../../helpers/array";
import { EntityHelper } from "../../helpers/entity";
import { IdHelper } from "../../helpers/id";
import { BaseEntityDtoAny } from "../../ts/entity";

export class BaseEntityMapper {
  public static mapToDataInputDtoLocal(
    source: BaseEntityDtoAny,
    dest: BaseEntityDataInputDto,
  ): BaseEntityDataInputDto {
    dest = {
      ...source,
    };
    if (dest.dataOriginMode && dest.dataOriginMode !== EntityDataOriginMode.None) {
      return dest;
    }

    const formMeta = EntityHelper.getEntityFormMeta(source);
    if (formMeta.entity) {
      dest = EntityHelper.switchEntityDataToRefMode(dest, formMeta.entity);
    } else if (formMeta.entityRef) {
      dest = EntityHelper.switchEntityDataToRefMode(dest, formMeta.entityRef);
    } else if (formMeta.entityFullRef) {
      dest = EntityHelper.switchEntityDataToRefMode(dest, formMeta.entityFullRef);
    } else if (formMeta.isData) {
      if (formMeta.dataMeta?.isRef) {
        dest = EntityHelper.switchEntityDataToRefMode(dest, null);
      } else if (formMeta.dataMeta?.isInline) {
        dest = EntityHelper.switchEntityDataToInlineMode(dest);
      }
    }
    return dest;
  }

  public static mapToDataInputDtoForBe(source: BaseEntityDataInputDto): BaseEntityDataInputDto {
    return {
      ...source,
      formType: source.formType || EntityFormType.Data,
      id: IdHelper.nullIfTempFeId(source.id),
      originalId: IdHelper.nullIfTempFeId(source.originalId),
      originalIds: source.originalIds
        ? ArrayHelper.undefinedIfEmpty(IdHelper.excludeTempFeIds(source.originalIds))
        : undefined,
      originalTenantId: IdHelper.nullIfTempFeId(source.originalTenantId),
    };
  }
}
